import { Pipe, PipeTransform } from '@angular/core'
import { Card } from '@mmx/shared'

@Pipe({
  name: 'cardImage',
  standalone: false,
})
export class CardImagePipe implements PipeTransform {
  transform(card: Card): string | undefined {
    const capitalizeFirstLetter = (string?: String) =>
      string && string.charAt(0).toUpperCase() + string.slice(1)

    if (!card.brand) {
      return
    }

    // create a local dictionary of card images
    let brand = capitalizeFirstLetter(card.brand)
    switch (brand) {
      case 'Amex':
        brand = 'American Express'
        break
      case 'Mastercard':
        brand = 'MasterCard'
        break
      default:
        break
    }
    return `/assets/images/payment-methods/${brand}.png`
  }
}
